import React from 'react'
import { DoctorProfile } from './DoctorProfile'
import { AppointmentBooking } from './AppointmentBooking'

const DoctorDetails = () => {
  return (
    //  <div className="min-h-screen bg-gray-50 py-8">
    //   <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
    //     <h1>DoctorDetails</h1>
    //   </div>
    //   </div>
    <div className="min-h-screen bg-background p-4 md:p-8">
      <div className="mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 lg:h-fit">
          <DoctorProfile />
          <AppointmentBooking />
        </div>
      </div>
    </div>
  )
}

export default DoctorDetails